const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '평가일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['평가일', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.평가일', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.평가일', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "평가대상",
        "key": "body.평가대상"
      },
      {
        "name": "평가일",
        "key": "body.평가일"
      },
      {
        name: "소속명",
        key: "author.company.com_name",
      },
      {
        name: "부서명",
        key: "body.stdInfo.section",
      },
      {
        name: "작성자",
        key: "author.name",
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name // 회사명
        case 1:
          return func.getContent(value).평가대상 // 평가대상
        case 2:
          return func.getContent(value).평가일 // 평가일
        case 3:
          return value.author.company.com_name; // 소속명
        case 4:
          return func.getContent(value).stdInfo.section || '-'; // 부서명
        case 5:
          return value.author.name || '-'; // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
